import { render, staticRenderFns } from "./wechatForm.vue?vue&type=template&id=4182a3d6&scoped=true&"
import script from "./wechatForm.vue?vue&type=script&lang=js&"
export * from "./wechatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4182a3d6",
  null
  
)

export default component.exports